import { render, staticRenderFns } from "./NewAyudaRepCobranzas.vue?vue&type=template&id=1b704a3b&scoped=true"
import script from "./NewAyudaRepCobranzas.vue?vue&type=script&lang=js"
export * from "./NewAyudaRepCobranzas.vue?vue&type=script&lang=js"
import style0 from "./NewAyudaRepCobranzas.vue?vue&type=style&index=0&id=1b704a3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b704a3b",
  null
  
)

export default component.exports